import { OutgoingMembershipDto } from 'api/dtos/memberships/products';
import bounceApiClient from 'legacy/common/utils/bounceApiClient';

export async function getCurrentUserOrganizationsMemberships(): Promise<
  OutgoingMembershipDto[]
> {
  const { data } = await bounceApiClient.get(`/api/me/memberships`);
  return data?.memberships || [];
}

export async function getCurrentUserOrganizationsMembershipById(
  membershipId: string
): Promise<OutgoingMembershipDto> {
  const { data } = await bounceApiClient.get(
    `/api/me/memberships/${membershipId}`
  );
  return data;
}

export async function cancelCurrentUserOrganizationsMembershipById(
  membershipId: string
): Promise<{ success: boolean }> {
  const { data } = await bounceApiClient.put(
    `/api/me/memberships/${membershipId}/cancel`
  );

  return data;
}

export async function getCurrentUserOrganizationAccessStatus(
  organizationId: string
): Promise<{ success: boolean }> {
  const params = {
    areaId: organizationId,
    areaType: 'organization'
  };
  const { data } = await bounceApiClient.get(`/api/me/membership-area/access`, {
    params
  });

  return data;
}
